import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';

export default Object.freeze({
	GENERAL: `${RouteNames.STORAGE}-general`,
	S3: `${RouteNames.STORAGE}-s3`,
});
